import { render } from "./ReposicionRuleModal.vue?vue&type=template&id=97ef377e"
import script from "./ReposicionRuleModal.vue?vue&type=script&lang=js"
export * from "./ReposicionRuleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__